import React from "react";
import classnames from "classnames";

import styles from "./Radio.module.css";

interface IObj {
  id: number;
  lower?: number;
  name: string;
  upper?: number;
}

interface Props {
  active: number;
  handler: (active: IObj) => void;
  label: string;
  list: IObj[];
}

function Radio(props: Props) {
  const { active, handler, label, list } = props;
  return (
    <div className={classnames(styles.container)}>
      <div className={styles.wrapper}>
        <div className={styles.label}>{label}</div>
        <div className={styles.value}>
          <div className={styles.list}>
            <ul>
              {list.map((item, index) => {
                const { id, name } = item;
                return (
                  <li
                    className={classnames(styles.item, {
                      [styles.active]: active === id
                    })}
                    key={index}
                    onClick={() => handler(item)}
                  >
                    <span>{name}</span>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Radio;
